import { render, staticRenderFns } from "./SmsVariable.vue?vue&type=template&id=497302c2&scoped=true"
import script from "./SmsVariable.vue?vue&type=script&lang=js"
export * from "./SmsVariable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497302c2",
  null
  
)

export default component.exports